module.exports = __webpack_public_path__ + "static/img/kwh_good1.235cc20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/kwh_good1.png
// module id = 6Nk4
// module chunks = 1